import { useConditionComparatorFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts/queryErrorState';

export const useHasConditionComparatorError = () => {
  const fieldPath = useConditionComparatorFieldPath();
  const { getHasErrorFromFieldPath } = useQueryErrorStateContext();
  const errorFromFieldPath = getHasErrorFromFieldPath(fieldPath);

  return errorFromFieldPath;
};
